import { render, staticRenderFns } from "./consumeDetail.vue?vue&type=template&id=0d025f6b&scoped=true"
import script from "./consumeDetail.vue?vue&type=script&lang=js"
export * from "./consumeDetail.vue?vue&type=script&lang=js"
import style0 from "./consumeDetail.vue?vue&type=style&index=0&id=0d025f6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d025f6b",
  null
  
)

export default component.exports